import { Reveal } from "@/components/Reveal";
import { Quote } from "lucide-react";

type Testimonial = {
  name: string;
  business: string;
  review: string;
};

// Only verified testimonial details are shown here — no photos, ratings or badges.
const testimonials: Testimonial[] = [
  {
    name: "Michael T.",
    business: "Kitchen & bathroom renovations",
    review:
      "Before FullScale, work came almost entirely from referrals — some weeks busy, some weeks quiet. Enquiries from Google are far more consistent now and our review profile looks much stronger.",
  },
  {
    name: "Andrew K.",
    business: "Electrical services",
    review:
      "The missed-call text-back has made a real difference. We used to lose jobs while we were on the tools, and now every enquiry gets a reply straight away.",
  },
  {
    name: "David R.",
    business: "Roofing & repairs",
    review:
      "We went from very few Google reviews to a steady stream of them. Customers trust us before we arrive and our quotes get accepted more often.",
  },
];

export function ResultsSection() {
  return (
    <section
      id="results-section"
      className="section-padding bg-background relative overflow-hidden"
      aria-labelledby="results-heading"
    >
      <div className="absolute inset-0 grid-pattern opacity-25" />

      <div className="container-wide relative z-10">
        <Reveal className="max-w-3xl mx-auto text-center mb-10 sm:mb-12">
          <span className="section-badge mb-4">Client Feedback</span>
          <h2
            id="results-heading"
            className="heading-section text-foreground mt-4 text-balance"
          >
            Trusted by Australian Trade and{" "}
            <span className="heading-accent">Service Businesses</span>
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 sm:gap-6">
          {testimonials.map((t, i) => (
            <Reveal key={t.name} delay={0.06 * i} className="h-full">
              <article className="h-full flex flex-col rounded-2xl border border-border/60 bg-card shadow-card p-6 sm:p-7 text-left">
                <Quote
                  className="w-6 h-6 text-primary/40 mb-4 -scale-x-100"
                  aria-hidden="true"
                />
                <blockquote className="text-base text-foreground/85 leading-[1.7] mb-6">
                  “{t.review}”
                </blockquote>
                <div className="mt-auto pt-4 border-t border-border/60">
                  <p className="text-base font-bold text-foreground">{t.name}</p>
                  <p className="text-base text-muted-foreground leading-[1.6]">
                    {t.business}
                  </p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
